<template>
    <b-card header-class="bar-color2" no-body>
        <template v-slot:header>
            <timeline-header
                :date="data.date"
                :time="data.date"
                :title="data.title"
            />
        </template>
    </b-card>
</template>

<script>
    import TimelineElementMixin from "@/components/surgery/detail/timeline/TimelineElementMixin";
    import TimelineHeader from "@/components/surgery/detail/timeline/TimelineHeader";

    export default {
        name: "TimelineDate",
        components: {TimelineHeader},
        mixins: [TimelineElementMixin],
    };
</script>

<style scoped>

</style>